import { usePathname, useRouter } from 'next/navigation';

import { uiStore } from '@stores/ui';

export function useApp() {
    const router = useRouter();
    const pathname = usePathname();

    const { showLoading, hideLoading, hasOptionsAvailable, setHasOptionsAvailable } = uiStore();

    return {
        goTo: (path: string) => router.push(path),
        pathname,
        showLoading,
        hideLoading,
        hasOptionsAvailable,
        setHasOptionsAvailable,
    };
}
